import React, { Fragment } from "react";
import { Formik } from "formik";

import { Box, CircularProgress } from "@mui/material";

import { notificationFormSchema } from "./schema/notifications.schema";

import { useNotificationForm } from "./hook/useNotificationForm";
import { INotificationFormMode } from "./hook/interface";

import NotificationForm from "./NotificationForm";
import PreviewModal from "../modal/PreviewModal";

interface Props {
  mode: INotificationFormMode;
}

const NotificationFormikContainer: React.FC<Props> = ({ mode }) => {
  const { state, actions } = useNotificationForm(mode);
  const { initialValues, previewOpen, imagePreviewUrl } = state;

  if (!initialValues) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={notificationFormSchema}
        onSubmit={actions.handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Fragment>
            <NotificationForm
              formikProps={formik}
              formHookValues={state}
              formHookActions={actions}
            />
            <PreviewModal
              open={previewOpen}
              onClose={actions.closePreview}
              title={formik.values.title}
              message={formik.values.message}
              imageUrl={imagePreviewUrl}
            />
          </Fragment>
        )}
      </Formik>
    </Fragment>
  );
};

export default NotificationFormikContainer;
